import { ModelHelper } from '../classes/model-helper';
import { Country } from './country.model';
import { Region } from './region.model';

export class Address {
	address1: string;
	address2: string;
	zipCode: string;
	city: string;
	region: Region;
	country: Country;
	recipient: string;
	latitude: number;
	longitude: number;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Address
	 */
	static map(data: any, item: Address = new Address()): Address {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Address
	 */
	public map(data: any): Address {
		ModelHelper.map(data, this, 'address1');
		ModelHelper.map(data, this, 'address2');
		ModelHelper.map(data, this, 'zipCode');
		ModelHelper.map(data, this, 'city');
		ModelHelper.map(data, this, 'country', Country);
		ModelHelper.map(data, this, 'region', Region);
		ModelHelper.map(data, this, 'recipient');
		ModelHelper.map(data, this, 'latitude');
		ModelHelper.map(data, this, 'longitude');

		return this;
	}

	/**
	 * Prepare company data for api
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		// Clone data
		let apiData: any = Address.map(JSON.parse(JSON.stringify(data)));

		// Process properties
		for (const [key, value] of Object.entries(apiData)) {
			// Check for own getDataForApi method
			if (value && (<any>value).getDataForApi) {
				apiData[key] = (<any>value).getDataForApi();
			} else {
				apiData[key] = JSON.parse(JSON.stringify(value));
			}
		}

		// Reduce to data with original properties
		apiData = ModelHelper.intersection(JSON.parse(JSON.stringify(data)), apiData);

		// Return data for api
		return apiData;
	}

	/**
	 * Check whether all necessary properties for the determination of the GeoLocation are filled for the address
	 */
	public isAddressComplete(): boolean {
		return this.address1 && this.address1.length > 0 && this.zipCode && this.zipCode.length > 0 && this.city && this.city.length > 0;
	}
}
